import CreateReturnVoucher from "@/features/return-voucher/components/createReturnVoucher";
import ReturnVoucherList from "@/features/return-voucher/components/returnVoucherList";
import ReturnVoucher from "@/features/return-voucher/pages/ReturnVoucher";
import ReturnVoucherDetails from "@/features/return-voucher/pages/ReturnVoucherDetails";

export const returnVoucherRoutes = {
  path: "/return-voucher",
  element: <ReturnVoucher />,
  children: [
    {
      path: "/return-voucher",
      element: <ReturnVoucherList />,
    },
    {
      path: "/return-voucher/create",
      element: <CreateReturnVoucher />,
    },
    {
      path: "/return-voucher/:id",
      element: <ReturnVoucherDetails />,
    },
  ],
};
